export default {
  isAuthenticated: false,
  currentUser: {},
  adminRolle: false,
  mitarbeiterAddressID: null,
  vlamsUsers: []
}
